import React, { useEffect, useState, useContext } from 'react';
import { Card, CardContent, Typography, CardActions, Button } from '@material-ui/core';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import Loading from '../shared/Loading';
import { BtnContext } from '../eir-mobile-card-container/EirMobileCardContainer';
function EirMobileCard(props) {
    const graphql = useApolloClient();
    const [isLoading, setIsLoading] = useState(false);
    const btnContext = useContext(BtnContext);
    var price = props.price + '';
    var prices = price.split('.');
    if (prices[0].charAt(0) === '0') {
        prices[0] = prices[0].substr(1);
    }
    if (prices[1] == undefined) {
        prices[1] = '00';
    }

    var cardWidth = '';

    useEffect(() => {
        if (localStorage.getItem('planIndex')) {
            calculateWidthHeight(localStorage.getItem('planIndex'));
        } else {
            calculateWidthHeight(1);
        }
    }, [props]);
    const calculateWidthHeight = selectedPlan => {
        try {
            let ulHeight = 0;
            let ulHeightTemp = 0;
            ulHeightTemp = props.features.length * 32;
            if (isNaN(localStorage.getItem('ulHeightTemp'))) {
                localStorage.setItem('ulHeightTemp', ulHeightTemp);
            } else {
                let ht = localStorage.getItem('ulHeightTemp');
                if (ht > ulHeightTemp) localStorage.setItem('ulHeightTemp', ht);
                else localStorage.setItem('ulHeightTemp', ulHeightTemp);
            }
            ulHeight = localStorage.getItem('ulHeightTemp') + 'px';
            if (window.innerWidth > 1200) {
                if (document.querySelector('.card-deck') != null) {
                    cardWidth =
                        document.querySelector('.card-deck').clientWidth /
                        document.querySelector('.card-deck').childNodes.length;
                    cardWidth = cardWidth - 24 + 'px';
                }

                for (var i = 0; i < document.querySelector('.card-deck').childNodes.length; i++) {
                    document.querySelector('.card-deck').childNodes[i].style.width = cardWidth;
                }
            } else {
                cardWidth = '313px';
                document
                    .querySelector('.slick-dots')
                    .childNodes[selectedPlan].childNodes[0].click();
                for (var k = 0; k < document.querySelector('.slick-track').childNodes.length; k++) {
                    document.querySelector('.slick-track').childNodes[k].style.width = cardWidth;
                }
            }
            for (
                var j = 0;
                j < document.getElementsByClassName('feature-mobile-wrapper').length;
                j++
            ) {
                document.getElementsByClassName('feature-mobile-wrapper')[
                    j
                ].childNodes[0].style.height = ulHeight;
            }
        } catch (error) {
            console.log('Error>>', error);
        }
    };
    const planSubmit = (event, props) => {
        localStorage.setItem(
            'planIndex',
            event.target.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute(
                'data-index'
            )
        );
        btnContext.countDispatch('true');
        setIsLoading(true);
        localStorage.removeItem('ACQ_PROSPECTUUID');
        localStorage.removeItem('CO_REF');
        localStorage.removeItem('CS_REF');
        localStorage.removeItem('ACQ_PORTIN');
        createProspect(props.ctaName);
    };

    const createProspect = async planID => {
        try {
            if (localStorage.getItem('prospectUuid')) {
                addOffer(planID);
            } else {
                const res = await graphql.mutate({
                    mutation: ENDPOINT.CREATE_PROSPECT,
                    variables: {
                        brand: props.openCMSProps.brand,
                        channelType: props.openCMSProps.channelType,
                        offerType: props.openCMSProps.offerType,
                    },
                });
                if (res.data.prospect) {
                    // console.log('gggg');
                    localStorage.setItem('IONOrderReference', res.data.prospect.orderReference);
                    localStorage.setItem('prospectUuid', res.data.prospect.prospectUuid);
                    document.cookie =
                        'eir_current_order= ;expires=Thu, 01 Jan 2000 00:00:00 UTC; path=/';
                    addOffer(planID);
                }
        }
    } catch (err) {
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
            console.log(err.message);
            btnContext.countDispatch('false');
            setIsLoading(false);
        }
    };

    const addOffer = async planID => {
        try {
            let offerName = props.openCMSProps.offerName;
            if (localStorage.getItem('offerId')) {
                addPlan(planID);
            } else {
                const res = await graphql.mutate({
                    mutation: ENDPOINT.ADD_OFFER,
                    variables: {
                        prospectUuid: localStorage.getItem('prospectUuid'),
                        offerName: offerName,
                    },
                });
                if (res.data.addOffer) {
                    localStorage.setItem('offerId', res.data.addOffer.offerId);
                    addPlan(planID);
                }
            }
        } catch (err) {
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
            console.log(err.message);
            btnContext.countDispatch('false');
            setIsLoading(false);
        }
    };
    const addPlan = async planID => {
        try {
            const res = await graphql.mutate({
                mutation: ENDPOINT.ADD_PLAN,
                variables: {
                    prospectUuid: localStorage.getItem('prospectUuid'),
                    cartOfferId: parseInt(localStorage.getItem('offerId')),
                    planId: planID,
                },
            });
            if (res.data.addPlan) {
                PubSub.publish(Constants.eventKeys.cartSubscriberAdded, res.data.addPlan);
                localStorage.setItem(
                    'plan-name',
                    props.openCMSProps.offerName + ' \u20AC' + prices[0]
                );
                window.location.href = props.submitPlanUrl;
                localStorage.removeItem('planIndex');
            }
        } catch (err) {
            props.getAPIError('Sorry, something went wrong,  please try again later.');
            props.getsetDialogOpenResponse(true);
            console.log(err.message);
            btnContext.countDispatch('false');
            setIsLoading(false);
        }
    };

    return (
        <div class="eir-mobile-card-wrapper">
            {props.promoString ? (                
                <div class="label-text-wrapper">
                    <div class="label-text">{props.promoString}</div>
                </div>
            ) : ''}
            <Card
                id={props.id}
                className={
                    (props.hero ? 'hero' : '') +
                    ' eir-mobile-card ' +
                    (props.prequalUrl ? 'eir-card-prequal' : '')
                }
                variant='outlined'
                spacing={2}>
                <CardContent className={'eir-card-body d-flex flex-column'}>
                    <h5 class='eir-card-title  card-title name-margin'>{props.name}</h5>
                    <div className='price-wrapper text-center'>
                        <h2 className='display-1 eir-card-price'>
                            &euro;{prices[0]}
                            <span>.{prices[1]}</span>
                        </h2>
                    </div>
                    {props.subtitles ? (
                        <div>
                            <Typography className='eir-mobile-card-subheadline'>
                                {props.subtitles}
                                <br />
                            </Typography>
                        </div>
                    ) : (
                        <div>
                            <Typography className='eir-mobile-card-subheadline'>
                                <br />
                            </Typography>
                        </div>
                    )}
                    <div className='eir-mobile-card-mainfeature'>{props.mainFeatures}</div>
                    <div className='feature-mobile-wrapper'>
                        <ul style={props.prequalUrl}>
                            {/*} <ul> {*/}
                            {props.features.map((feature, index) => {
                                return (
                                    <li
                                        key={'eircard-feature' + index}
                                        className='card-text eir-card-feature'>
                                        {feature}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </CardContent>
                <CardActions className='eir-card-footer action-alignment card-footer-button'>
                    {isLoading ? (
                        <Loading />
                    ) : (
                        <Button
                            disabled={props.btn}
                            // variant='contained'
                            // color='primary'
                            className='mobile-button'
                            onClick={e => {
                                planSubmit(e, props);
                            }}
                            name={props.ctaName}>
                            {props.openCMSProps.ctaText}
                        </Button>
                    )}
                </CardActions>
            </Card>
        </div>
    );
}
export default EirMobileCard;